import { createRouter, createWebHistory } from 'vue-router';

import store from '@/store';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'), //Home
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'), //Login,
    beforeEnter: () => {
      let key = localStorage.getItem('session-nrm-spec');

      return !key ? true : { name: 'Home' };
    },
  },
  {
    path: '/set-classifiers/:curr/:old',
    name: 'SetClassifiers',
    component: () => import('@/views/Home.vue'), //Home,
    props: (route) => ({
      curr: route.params.curr,
      old: route.params.old,
    }),
    beforeEnter: (to) => {
      localStorage.setItem(`curr-classifier-nrm-spec`, to.params.curr);

      if (to.params.curr !== to.params.old) {
        localStorage.setItem(`old-classifier-nrm-spec`, to.params.old);
      } else if (to.params.old === store.getters.getDefaultClassifiers('addition')) {
        localStorage.setItem(`old-classifier-nrm-spec`, store.getters.getDefaultClassifiers('main'));
      } else {
        localStorage.setItem(`old-classifier-nrm-spec`, store.getters.getDefaultClassifiers('addition'));
      }

      return {
        path: '/',
      };
    },
  },
  {
    path: '/cleanup',
    name: 'Cleanup',
    component: () => import('@/views/Cleanup.vue'), //Cleanup
  },
  {
    path: '/markup',
    name: 'Markup',
    component: () => import('@/views/Markup.vue'), //Markup
  },
  {
    path: '/create/:id',
    name: 'Create',
    component: () => import('@/views/SpecificationCreate.vue'), //SpecCreate,
    props: (route) => ({ id: route.params.id, query: route.query.classifier }),
  },
  {
    path: '/classifiers',
    component: () => import('@/views/ClassifiersEdit.vue'), //ClassifiersEdit,
    name: 'Classifiers',
    children: [
      {
        path: '',
        name: 'ClassifiersSelect',
        component: () => import('@/components/Classifier/ClassifiersSelect'), //ClassifiersSelect,
      },
      {
        path: 'create',
        name: 'ClassifiersCreate',
        component: () => import('@/components/Classifier/ClassifiersCreate'), //ClassifiersCreate,
      },
      {
        path: 'tables/:id',
        name: 'ClassifierTables',
        component: () => import('@/components/Classifier/ClassifierTables'), //ClassifierTables,
        props: (route) => ({ id: route.params.id }),
      },
      {
        path: 'upload',
        name: 'ClassifierUpload', //'UploadTables',
        component: () => import('@/components/Classifier/UploadTables'), //UploadTables,
      },
    ],
  },
  {
    path: '/update/:curr/:old/:id',
    name: 'Update',
    component: () => import('@/views/SpecificationUpdate.vue'), //SpecUpdate,
    props: (route) => ({
      curr: route.params.curr,
      old: route.params.old,
      id: route.params.id,
    }),
  },
  {
    path: '/404',
    component: () => import('@/views/NotFound.vue'), //NotFound,
    name: 'NotFound',
  },
  {
    path: '/403',
    component: () => import('@/views/NotAccess.vue'), //NotAccess,
    name: 'NotAccess',
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/404',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
});

router.beforeEach(async (to) => {
  let key = localStorage.getItem('session-nrm-spec');
  if (to.name === 'Create' || to.name === 'Update') store.dispatch('setRedirectPage', to.fullPath);
  if (to.name === 'Home') store.dispatch('setRedirectPage', null);

  if (!key && to.name !== 'Login') {
    const route = { name: 'Login' };

    if (store.getters.currRedirectPage) {
      let hash = { redirect: store.getters.currRedirectPage };
      route.query = hash;
    }

    return route;
  } else if (key && !store.getters.currEditor) {
    await store.dispatch('getUserData');
  }

  return true;
});

export default router;
